import React, { memo } from 'react';

import { IconButton, Typography } from '@mui/material';
import { DeleteIcon, ResetIcon } from '@sharedCR/coreDesignSystem/icons';
import dayjs from 'dayjs';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import { COMMON_DATETIME_FORMAT } from 'constants/date';

import { PropertyAndLoanTestIds } from '../../../../../PropertyAndLoan.testIds';
import { BadgeWrapper } from '../../sharedComponents';

const LoanTag = ({ loanTag, isLoading, onDeleteLoanTag, onRestoreLoanTag, isControlVisible }) => {
  const {
    isNewAdded,
    isDeleted,
    isInitiallyNewAdded,
    isInitiallyDeleted,
    tagName,
    assignedDate,
    tagId,
  } = loanTag;

  const isUnknownDate = isNewAdded || isInitiallyNewAdded;

  const isHighlighted = [isNewAdded, isDeleted, isInitiallyNewAdded, isInitiallyDeleted].some(
    Boolean,
  );

  return (
    <BadgeWrapper
      control={
        isControlVisible ? (
          <IconButton
            color="primary.main"
            data-tag-id={tagId}
            data-testid={PropertyAndLoanTestIds.getLoanTagActionButtonId(tagId)}
            disabled={isLoading || isInitiallyDeleted}
            onClick={isDeleted || isInitiallyDeleted ? onRestoreLoanTag : onDeleteLoanTag}
          >
            {isDeleted || isInitiallyDeleted ? (
              <ResetIcon size={IconSize[24]} />
            ) : (
              <DeleteIcon size={IconSize[24]} />
            )}
          </IconButton>
        ) : null
      }
      isDeleted={isDeleted || isInitiallyDeleted}
      isHighlighted={isHighlighted}
      textContent={
        <>
          <Typography
            data-truncated
            className="truncate overflow-hidden pr-4"
            color={isUnknownDate ? 'text.tableHighlight' : 'text.dark'}
            component="p"
            variant="regularItalic12"
          >
            {isUnknownDate
              ? 'Date will be updated'
              : dayjs(assignedDate).format(COMMON_DATETIME_FORMAT)}
          </Typography>
          <Typography
            data-truncated
            className="truncate overflow-hidden"
            color={isHighlighted ? 'text.tableHighlight' : 'text.black'}
            component="p"
            variant="bold16"
          >
            {tagName}
          </Typography>
        </>
      }
    />
  );
};

LoanTag.propTypes = {
  loanTag: PropTypes.object.isRequired,
  isControlVisible: PropTypes.bool.isRequired,
  onDeleteLoanTag: PropTypes.func.isRequired,
  onRestoreLoanTag: PropTypes.func.isRequired,
  ...WithLoadingPropTypes,
};

export default memo(LoanTag);
